export class QuestionType {

  id?: string;
  isEnabled?: boolean;
  isValueCountable?: boolean;
  nameTranslationKey?: string;
  private translationKeys = {  };

  constructor(values= {}) {
    this.translationKeys['FIVE-STARS'] = 'SATISFACTION.QUESTIONTYPE.FIVESTARS';
    this.translationKeys['TEXT'] = 'SATISFACTION.QUESTIONTYPE.OPENTEXT';
    this.translationKeys['NPS'] = 'SATISFACTION.QUESTIONTYPE.NPS';
    Object.assign(this, values);
    this.nameTranslationKey = this.translationKeys[this.id];
  }

}
